import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import storage from "redux-persist/lib/storage";
// import { persistReducer, persistStore } from "redux-persist";
import {
  authApi,
  clientApi,
  staffApi,
  fileApi,
  companyProfileApi,
  invoiceDetailApi,
  contractorApi,
  SalaryDetailApi,
  invoiceBankApi,
  taskApi,
  employeeApi,
  attendanceApi,
  holidayApi,
  leaveApi,
  requestsApi,
  thoughtsApi,
  announcementsApi,
  marketingApi,
  attendanceRequestApi,
  notesApi
} from "../service";



import authSlice from "./authSlice";
import clientReducer from './clientSlice';
import contractorReducer from './contractorSlice';
import staffReducer from './staffslice';
import employeeReducer from './employeeSlice';
import taskReducer from './taskslice';
// import leaveReducer from './leaveRequestSlice';
const appReducer = combineReducers({

  
  authState: authSlice,
  [authApi.reducerPath]: authApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [staffApi.reducerPath]: staffApi.reducer,
  [fileApi.reducerPath]: fileApi.reducer,   
  [notesApi.reducerPath]: notesApi.reducer,   
  [companyProfileApi.reducerPath]: companyProfileApi.reducer, 
  [ invoiceDetailApi.reducerPath]: invoiceDetailApi.reducer,
  [ contractorApi.reducerPath]: contractorApi.reducer,
  [ SalaryDetailApi.reducerPath]: SalaryDetailApi.reducer,
  [ taskApi.reducerPath]: taskApi.reducer,
  [invoiceBankApi.reducerPath]:invoiceBankApi.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
  [attendanceApi.reducerPath]: attendanceApi.reducer,
  [holidayApi.reducerPath]: holidayApi.reducer,
  [leaveApi.reducerPath]: leaveApi.reducer,
  [requestsApi.reducerPath]: requestsApi.reducer,
  [thoughtsApi.reducerPath]: thoughtsApi.reducer,
  [announcementsApi.reducerPath]: announcementsApi.reducer,
  [marketingApi.reducerPath]: marketingApi.reducer,
  [attendanceRequestApi.reducerPath]: attendanceRequestApi.reducer,
  employee: employeeReducer,
  client: clientReducer, 
  staff: staffReducer, 
  task: taskReducer, 
  contractor: contractorReducer, 

});

export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authApi.middleware,
      notesApi.middleware,
      clientApi.middleware,
      staffApi.middleware,
      fileApi.middleware,
      companyProfileApi.middleware,
      invoiceDetailApi.middleware,
      contractorApi.middleware,
      SalaryDetailApi.middleware,
      taskApi.middleware,
      invoiceBankApi.middleware,
      employeeApi.middleware,
      attendanceApi.middleware,
      holidayApi.middleware,
      leaveApi.middleware,
      requestsApi.middleware,
      thoughtsApi.middleware,
      announcementsApi.middleware,
      marketingApi.middleware,
      attendanceRequestApi.middleware,
    ]),
});